import {
    createBrowserStorageHook,
    createStatelessBrowserStorageHook,
} from './use-browser-storage';

/**
 * Gets and sets local storage values.
 * @param key the key of the localStorage item
 * @param initialValue the initial value, or function to determine the initial value
 */

export const useLocalStorage = 
createBrowserStorageHook(window.localStorage);
export const useStatelessLocalStorage = 
    createStatelessBrowserStorageHook(
        window.localStorage,
);